import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Button, Card, CardBody, Col, Row } from 'reactstrap'
import { Users } from 'react-feather'
import { newFormatThousandSeparator } from 'utils/formatNumber'

const WageSalaryFooter = ({ batchData, items = [], selectedRows = [] }) => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth)
  const { isOpenNavbar } = useSelector((s) => s.dashboard)
  const isTabletOrDesktop = screenWidth >= 768

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth)
    }

    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const uniqueEmployeesCount = new Set(
    items.map((i) => i.employeeUserId || i.employeeName).filter(Boolean)
  ).size

  const recipientsCount =
    batchData?.totalEmployees ||
    batchData?.recipients ||
    (uniqueEmployeesCount > 0 ? uniqueEmployeesCount : items.length)

  const hasSelections = selectedRows && selectedRows.length > 0
  const selectedCount = hasSelections ? selectedRows.length : items.length

  const totalAmount =
    batchData?.totalAmount ||
    batchData?.total ||
    items.reduce((acc, curr) => acc + (curr.amount || 0), 0)

  const selectedTotal = hasSelections
    ? selectedRows.reduce((acc, curr) => acc + (curr.amount || 0), 0)
    : items.reduce((acc, curr) => acc + (curr.amount || 0), 0)

  return (
    <>
      <Card
        className="border-0 shadow-lg mt-4"
        style={{
          position: 'fixed',
          bottom: 0,
          backgroundColor: '#FDFBF7',
          width: isTabletOrDesktop
            ? `calc(96% - ${isOpenNavbar ? '253px' : '53px'})`
            : `calc(96% - 15px)`,
          zIndex: 1,
          borderRadius: '16px 16px 0 0',
          boxShadow: '0 -4px 12px rgba(0, 0, 0, 0.15)',
        }}
      >
        <CardBody className="p-4">
          <Row className="align-items-center">
            <Col xs="12" md={hasSelections ? '4' : '6'} className="d-flex align-items-center gap-3">
              <div className="bg-light p-2 rounded-circle text-primary">
                <Users size={24} />
              </div>
              <div className="d-flex flex-column text-muted" style={{ fontSize: '14px' }}>
                <span>{recipientsCount} karyawan</span>
                {hasSelections && <span>{selectedCount} dipilih</span>}
              </div>
            </Col>

            {hasSelections && (
              <Col xs="12" md="4" className="d-flex flex-column mt-3 mt-md-0">
                <span className="text-muted" style={{ fontSize: '14px' }}>Total terpilih</span>
                <span className="fw-bold" style={{ fontSize: '20px' }}>
                  Rp{newFormatThousandSeparator(selectedTotal || 0, 0)}
                </span>
              </Col>
            )}

            <Col xs="12" md={hasSelections ? '4' : '6'} className="d-flex flex-column mt-3 mt-md-0">
              <span className="text-muted" style={{ fontSize: '14px' }}>Total due dibayar</span>
              <span className="fw-bold" style={{ fontSize: '20px' }}>
                Rp{newFormatThousandSeparator(totalAmount || 0, 0)}
              </span>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <div style={{ height: '110px' }}></div>
    </>
  )
}

export default WageSalaryFooter
